import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getAccounts = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  if (req.type) queryParams.set("type", req.type);
  return await customFetch(
    `v1/account?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const getAccount = async (id: string) => {
  return await customFetch(`v1/account/${id}`, {
    method: "GET",
  });
};
export const createAccount = async (data: any) => {
  return await customFetch("v1/account", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateAccount = async (id: string, data: any) => {
  return await customFetch(`v1/account/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteAccount = async (id: string) => {
  return await customFetch(`v1/account/${id}`, {
    method: "DELETE",
  });
};

